<template>
  <div>
    <CardedTable :items="items" :headers="headers">
      <template v-slot:[`item.icon`]="{ item }">
        <v-icon>{{ item.icon }}</v-icon>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminSubCategoriesList",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: false,
    },
  },
  data: () => {
    return {
      items: [],
      headers: [
        {
          text: "Icon",
          align: "start",
          sortable: false,
          value: "icon",
          filterable: false,
        },
        { text: "Name", value: "name" },
        {
          text: "Category",
          value: "category.name",
          align: "center",
          filterable: false,
        },
        { text: "Busineses", value: "belongings.length", align: "center" },
        { text: "", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    on_view_item(item) {
      this.$router.push("/admin/categories/sub_categories/view/" + item.id);
    },
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Categories.get_sub_categories(
        {
          is_admin: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.items = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading sub categories on admin categories list"
          );
        }
      );
    },
  },
  mounted() {
    this.$emit("set-page-attributes", {
      title: "Sub Categories List",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Categories",
          disabled: false,
          href: "/admin/categories",
        },
        {
          text: "Sub Categories List",
          disabled: true,
          href: "/admin/categories/sub_categories/list",
        },
      ],
    });
    this.load_items();
  },
};
</script>